import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type { BhojanScheme, BhojanSchemePayload } from "@project/types/bhojan";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/bhojan-schemes`;
const SILENT: RequestConfig = { showNotification: false };

class BhojanSchemeService {
  listPage = (query: ListQuery = {}): Promise<PaginatedResult<BhojanScheme>> =>
    fetchListPage<BhojanScheme>(`${BASE}/`, query);

  get = async (id: number): Promise<BhojanScheme | undefined> => {
    const data = await get<ApiItemResponse<BhojanScheme> | BhojanScheme>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  create = async (payload: BhojanSchemePayload): Promise<BhojanScheme> => {
    const data = await post<
      ApiItemResponse<BhojanScheme> | BhojanScheme,
      BhojanSchemePayload
    >(`${BASE}/`, payload, SILENT);
    const item = unwrapItem(data);
    if (!item) {
      throw new Error("Failed to create bhojan scheme.");
    }
    return item;
  };

  update = async (
    id: number,
    payload: Partial<BhojanSchemePayload>
  ): Promise<BhojanScheme | undefined> => {
    const data = await patch<
      ApiItemResponse<BhojanScheme> | BhojanScheme,
      Partial<BhojanSchemePayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const bhojanSchemeService = new BhojanSchemeService();
